function addClassDelay(element, className, delay, index) {
    let $addClassDelayElement = element, $addClassName = className,
        i = index;
    setTimeout(function(){
      let stepsAnimation = document.getElementById('stepsAnimation');
      let steps = stepsAnimation.querySelectorAll('.step');
  
      for (let j = 0; j < steps.length; j++) {
        steps[j].classList.remove('step-animate');
        steps[j].classList.remove('step-animate-start');
      }
  
      $addClassDelayElement.classList.add($addClassName);
  
      if (i === 3) {
        steps[0].classList.add('step-animate-start');
        animateSteps(3000);
      }
    }, delay);
  }
  
  function animateSteps(delay) {
    let stepsAnimation = document.getElementById('stepsAnimation');
    let steps = stepsAnimation.querySelectorAll('.step');
  
    for (let i = 0; i < steps.length; i++) {
      addClassDelay(steps[i], 'step-animate', (i + 1) * delay, i);
    }
  }
  
  animateSteps(3000);